function logCredits(){
    return 0
}

function addVariantToCart(id){
    if(!id) return 

    const formData = {
        id: id,
        quantity: 1,
    }
    fetch('/cart/add.js', {
        method: 'POST', 
        headers: { "Content-Type": "application/json"},
        body: JSON.stringify(formData),
    }).then(data=> {
        return data.json()
    }).then(()=>{
        RknCartHelpers.refreshCartDrawer()
        RknCartHelpers.openMiniCart()
    })

}


class RknCartHelpers {

    static refreshCartDrawer() {
        document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }

    static openMiniCart() {
        const cartDrawer = document.querySelector('a[aria-controls="cart-drawer"]');

        if (cartDrawer) {
            cartDrawer.setAttribute("aria-expanded", "true");
            cartDrawer.click();
        }
    }
}
